import { FunctionComponent } from "react";
import { useBanner } from "../Custom Hooks/useBanner";
import { BrokerIssuerBanner } from "@sgi/gravity/BrokerIssuerBanner";
import mobileBlueVector from "../Images/mobile_blue_vector.svg";
import mobileYellowVector from "../Images/mobile_yellow_vector.svg";
import desktopBlueVector from "../Images/desktop_blue_vector.svg";
import desktopYellowVector from "../Images/desktop_yellow_vector.svg";
import mainBanner from "../Images/mainbanner.jpg";

const backgroundImageStyle = {
  backgroundImage: `url(${mainBanner})`,
};

export const Banner: FunctionComponent = () => {
  const { issuerId, brokerId } = useBanner();
  return (
    <div
      className="banner"
      data-testid="banner-test"
      style={backgroundImageStyle}
    >
      {issuerId && <BrokerIssuerBanner issuerNumber={issuerId} />}
      {brokerId && <BrokerIssuerBanner brokerNumber={brokerId} />}
      <Vectors />
    </div>
  );
};

const Vectors: FunctionComponent = () => {
  return (
    <div className="vectors">
      <picture>
        <source media="(min-width: 1135px)" srcSet={desktopBlueVector} />
        <source media="(max-width: 1134px)" srcSet={mobileBlueVector} />
        <img src={desktopBlueVector} alt="" />
      </picture>
      <picture>
        <source media="(min-width: 1135px)" srcSet={desktopYellowVector} />
        <source media="(max-width: 1134px)" srcSet={mobileYellowVector} />
        <img src={desktopYellowVector} alt="" />
      </picture>
    </div>
  );
};

export default Banner;
